import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type PromotionList } from 'schemas';
import { fetchPromotions } from './promotionsThunks';
import { PROMOTIONS_SLICE_NAME } from '../slicesNames';
import { type PromotionsState } from './promotion.types';

const initialState: PromotionsState = {
  promotions: [],
  isLoading: false,
  isLoaded: false,
  error: null,
};

const promotionsSlice = createSlice({
  name: PROMOTIONS_SLICE_NAME,
  initialState,
  reducers: {
    updatePromotions(state, action: PayloadAction<PromotionList>) {
      state.promotions = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPromotions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPromotions.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch promotions';
        state.isLoading = false;
        state.isLoaded = true;
      })
      .addCase(fetchPromotions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoaded = true;
        state.promotions = action.payload;
      });
  },
});

export default promotionsSlice;
export const promotionsActions = promotionsSlice.actions;
